import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const Features = () => {
    return (

        <div className="">
            <div className='position-relative' style={{ backgroundImage: `url(https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60,w_${window.innerWidth},h_${window.innerHeight}/https://img.freepik.com/free-vector/abstract-background-with-pink-purple-flowing-lines-design_1048-20364.jpg?t=st=1743033102~exp=1743036702~hmac=b10f2e0856ce6c240b75c65af8044f7a15f20335d40393ec94fa8ef830ab4dca&w=900)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                <div style={{ zIndex: '20' }} className='shade'></div>
                <div style={{ zIndex: '30' }} className='position-relative'>
                    <div className="container-fluid py-5">
                        <div className="px-md-5">
                        <div className="px-3">
                            <div className="row py-5">
                                <div className="col-md-6 col-12">
                                    <h1 className="text-light">VTC – The Future of Smart Investments!
                                    </h1>
                                </div>
                                <div className="col-md-6 col-12 px-md-5">
                                    <div className="px-md-5">
                                        <p className="text-light">A Smarter, More Profitable Way to Invest in Your Financial Future!</p>
                                        <button className="btn btn-light">Join VTC</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div data-aos="fade-up" data-aos-duration="1000" class="card rounded-4 h-100 overflow-hidden" style={{ borderColor: "#fff",backgroundColor:"#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-1 h1' ><i style={{ color: '#fff' }} class={`fa-solid fa-user-secret fa-lg`}></i></p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title display-6 text-light">Secure & Decentralized                                        </h2>
                                        <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>
                                        <div className='d-flex justify-content-center align-items-end' style={{ flex: 1 }}>
                                            {/* <Link ref={quoteRef} style={{ borderColor: '#6565ff' }} to={'/contact'} onClick={() => window.scrollTo({ top: 0, bottom: 0, behavior: 'smooth' })} class="btn btn-primary">Get A Quote</Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div data-aos="fade-up" data-aos-duration="1000"  class="card rounded-4 h-100 overflow-hidden" style={{ borderColor: "#fff",backgroundColor:"#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <p className='display-1 h1' ><i style={{ color: '#fff' }} class={`fa-solid fa-lg fa-sack-dollar`}></i></p>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title display-6 text-light">Reliable Staking & Rewards                                        </h2>
                                        <p class="card-text text-light">Earn 0.4% daily profit, referral bonuses, and passive income</p>
                                        <div className='d-flex justify-content-center align-items-end' style={{ flex: 1 }}>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4 col-12 my-2">
                                <div data-aos="fade-up" data-aos-duration="1000"  class="card rounded-4 h-100 overflow-hidden" style={{ borderColor: "#fff",backgroundColor:"#23153c" }}>
                                    {/* <img src="..." class="card-img-top" alt="..."/> */}
                                    <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                        <div className="d-flex">
                                            <p className='display-1 h1 px-2' ><i style={{ color: '#fff' }} class={`fa-solid fa-lg fa-bolt`}></i></p>
                                            {/* <p className='display-1 h1 px-2' ><i style={{ color: '#fff' }} class={`fa-brands fa-android fa-xl`}></i></p> */}
                                        </div>
                                    </div>
                                    <div class="card-body d-flex flex-column">
                                        <h2 class="card-title display-6 text-light">Autonomous Transactions                                        </h2>
                                        <p class="card-text text-light">Instant smart contract execution with PancakeSwap liquidity locked for 10 years</p>

                                        <div className='d-flex justify-content-center align-items-end' style={{ flex: 1 }}>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    </div>
                </div>

            </div>

        </div>

    )
}

export default Features